import teras from './teras'
import aes from './aes'
import { Axios } from 'axios'

class tAxios extends Axios {
    constructor (args) {
        super({
            withCredentials: true,
            validateStatus: function(status) {
                return status >= 200 && status < 300 && status != 210;
            },
            transformResponse: [(data) => {
                if (typeof data === 'string') {
                    if(this.aes)
                        data = JSON.parse(aes.decode(data))
                    data = JSON.parse(data)
                }
                return data;
            }],
        })
        console.log(this)
        this.apiUrl = 'https://api.biomedia.net/201706/'
        this.aes =  ((process.env.NODE_ENV != 'development') ? 1 : 0)
        this.defaults.headers = {'X-Request-ID': teras.name,'X-aes': this.aes}
        this.sessionID = ''
        this.mysql = {
            composer:'db',
            db:{database: 'bm_bams'}
        }
        this.sessionInterval = setInterval(() => { this.get(this.apiUrl+'vue/updatesession/')  }, 120000)
    }
    
    sessionGet(key){
        return this.post(this.apiUrl+'vue/sessionget',{key:key}).then((response) =>  {
            return response.data.data
        })
    }
    sessionSet(key,value){
        return this.post(this.apiUrl+'vue/sessionset',{key:key,value:value}).then((response) =>  {
            console.log("SETTATO SESSION KEY")
            console.log(response.data.data)
            return response.data.data
        })
    }
    logout(){
        this.get(this.apiUrl+'vue/logout')
    }
    

    query(fetch,query,params){
        var mySql ={
            db: this.mysql.db,
            sqlFetch: fetch,
            sqlQuery: query,
            sqlParams: params
        }
        var argumentsLength = arguments.length;
        if(arguments.length>3)
            var param2set = arguments[3]
        if(arguments.length>4)
            var key2set = arguments[4]

            console.log(arguments)

        return this.post(this.apiUrl+this.mysql.composer+'/query',mySql).then((response) =>  {
            var api = response.data
            console.log("ARRIVO A VERIFICARE SE SETTARE LA VARIABILE")
            console.log(typeof param2set)
            console.log("TYPEOF "+argumentsLength+" "+key2set)
            console.log(api)
            if(argumentsLength > 3 && typeof param2set != 'undefined'){
                console.log("TROVATA LA VARIABILE")
                if(typeof key2set != 'undefined'){
                    param2set[key2set] = api.data.result
                }else{
                    param2set = api.data.result
                }
            }
            console.log(api.data)
            return api.data
        }).catch((error) => {
            console.log("ERROR AL QUERY")
            console.log(error)
            return error
        })
    }

    insertRows(rows,table){
        var mySql ={
            db: this.mysql.db,
            table:table,
            rows: rows
        }
        return this.post(this.apiUrl+this.mysql.composer+'/insertrows',mySql).then((response) =>  {
            return response.data
        }).catch((error) => {
            console.log("ERROR AL QUERY")
            console.log(error)
            return error
        })
    }    

}

export default new tAxios


// WEBPACK FOOTER //
// ./src/axios.js